import React, {useEffect, useRef, useState} from 'react';

const AudioPlayer = ({filename}) => {
    const [audioUrl, setAudioUrl] = useState('');
    const [isPlaying, setIsPlaying] = useState(false);
    const audioRef = useRef(null);

    useEffect(() => {
        if (filename) {
            const url = `/static/${filename}.mp3`;

            fetch(url)
                .then(response => response.blob())
                .then(blob => {
                    const newAudioUrl = URL.createObjectURL(blob);
                    setAudioUrl(newAudioUrl);
                })
                .catch(error => console.error('Error fetching the audio file:', error));
        }
    }, [filename]);

    useEffect(() => {
        const audioElement = audioRef.current;

        const handleEnded = () => {
            setIsPlaying(false);
        };

        if (audioElement) {
            audioElement.addEventListener('ended', handleEnded);
            return () => {
                audioElement.removeEventListener('ended', handleEnded);
            };
        }
    }, []);

    const handlePlayPause = () => {
        if (audioRef.current) {
            if (isPlaying) {
                audioRef.current.pause();
                setIsPlaying(false);
            } else {
                audioRef.current.play()
                    .then(() => {
                        setIsPlaying(true);
                    })
                    .catch(error => {
                        console.error('Playback failed:', error);
                    });
            }
        }
    };

    return (
        <div>
            <audio ref={audioRef} src={audioUrl} />
            <button onClick={handlePlayPause}>
                {isPlaying ? 'Pause' : 'Play'}
            </button>
        </div>
    );
};

export default AudioPlayer;
